import { makeSimpleDigitalSensorElement } from "./simpleDigitalSensorElements.js";

/**
 * Whether a device output is currently energized: 0 for closed / de-energized / stopped, 1 for open /
 * energized / running.
 *
 * Replaces the old `valveState` element, which stored a device-wide bitfield packing both valves' open
 * and automating flags plus the manual-override flag into one value. That could not describe a single
 * output honestly — on a two-valve device each port's stream carried the other port's bits — and it was
 * not aggregatable. A plain 0/1 per output is, so averaging over a window gives the fraction of time
 * that output was active.
 *
 * Operating mode moved to its own sub-channel; see `outputOperatingModeSensorElement`.
 */
export const outputPositionElementConfig = makeSimpleDigitalSensorElement("state", 1);
